import { gql } from '@apollo/client'

export const me = gql`
  query Me {
    me {
      id
      email
      name
      timezone
      userEmails {
        id
        email
        active
      }
      favouriteCharities {
        id
        accountName
        mailingAddress
        city
        province
      }
      charityUsers {
        id
        title
        firstLogin
        userId
        charityId
        charity {
          id
          accountName
        }
        charityInvite {
          id
          status
          token
        }
      }
      funds {
        id
        name
        number
        closed
        fundProfile {
          id
          identityKind
          portalName
          craRecognisedName
          phone
          address {
            lineOne
            lineTwo
            postalCode
            province
            city
            country
          }
        }
      }
      userRoles {
        id
        fundId
        role {
          id
          name
          displayName
        }
        fund {
          id
          name
          closed
        }
      }
      fundProfiles {
        id
        fundType
        closed
        fundId
        portalName
      }
      isOrganization
      corporateName
      profile {
        id
        firstName
        lastName
        middleInitials
        phone
      }
      impersonator {
        id
        email
        name
        profile {
          firstName
          lastName
          phone
        }
      }
    }
  }
`

export const getAllUsers = gql`
  query allUsers {
    allUsers {
      id
      email
      name
      funds {
        name
      }
    }
  }
`

export const getUser = gql`
  query GetUser($userId: Float!) {
    getUser(id: $userId) {
      id
      name
      status
      confirmationToken
      charityUsers {
        charityInvite {
          status
        }
      }
    }
  }
`

export const getUserByEmail = gql`
  query GetUserByEmail($email: String!) {
    getUserByEmail(email: $email) {
      id
      email
      status
      confirmedAt
      funds {
        id
        name
        number
      }
      charityUsers {
        id
      }
    }
  }
`

export const getUserEmails = gql`
  query GetUserEmails($id: Float!) {
    getUserEmails(id: $id) {
      id
      userId
      email
      confirmedAt
      active
    }
  }
`

export const myAdvisorCustodianSettings = gql`
  query MyAdvisorCustodianSettings {
    myAdvisorCustodianSettings {
      custodianName
      advisorName
      advisorEmail
      advisorPhone
      advisorDealerRepCode
      address {
        lineOne
        city
        province
        postalCode
      }
    }
  }
`

export const suggestedCustodianName = gql`
  query SuggestedCustodianName {
    suggestedCustodianName
  }
`

export const myTableColumnPreferences = gql`
  query MyTableColumnPreferences($tableId: String!) {
    myTableColumnPreferences(tableId: $tableId)
  }
`
